import React from 'react';
const isBrowser = () => typeof window !== 'undefined';
const userAgent = isBrowser() ? navigator.userAgent : '';
export const UserAgentContext = React.createContext(userAgent);
//# sourceMappingURL=UserAgentContext.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
